import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const Dashboard = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { page } = location.state || {};
  console.log("hello from dashboard");
  console.log("page: ", page);

  useEffect(() => {
    if (page) {
      // Reset the page value to null or empty
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, page: null }, // or page: ''
      });
    }
  }, [location, navigate, page]);

  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");
  const raerAcess = localStorage.getItem("raerAcess");

  useEffect(() => {
    console.log(raerAcess);
    if (raerAcess != "1" || !tokena) {
      navigate("/login");
      return;
    }
  });

  const [value, setValue] = useState(page === "adminProcess" ? 0 : 1);

  const [orders, setOrders] = useState([]);

  const [searchField, setSearchField] = useState({
    product: "",
    order: "",
    blogs: "",
    users: "",
  });

  const dashboardHandler = () => {
    setValue(1);
  };

  const [contactInfo, setContactInfo] = useState([]);

  const getAllContactInfo = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getAllOrders`,
      method: "get",
    };

    try {
      const response = await axios.request(config);
      console.log("Hello");
      console.log(response?.data?.data);

      if (response?.data?.status === true) {
        setOrders(response?.data?.data);
        // toast.success("Product fetched successfully", {
        //   position: "bottom-right",
        //   autoClose: 4000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "light",
        // });
      } else if (response?.data?.status === false) {
        const { response_code } = response.data;
        const errorMessage =
          response_code === 500 || response_code === 404
            ? "Problem with data fetching"
            : "Unknown error";

        // toast.error(errorMessage, {
        //   position: "bottom-right",
        //   autoClose: 4000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "light",
        // });
      }
    } catch (error) {
      const errorCode = error?.response?.data?.response_code;
      const errorMessage =
        errorCode === 401
          ? "Your token is expired. Please login again."
          : "Problem with data fetching";

      const toastType = errorCode === 401 ? toast.error : toast.warn;

      // toastType(errorMessage, {
      //   position: "bottom-right",
      //   autoClose: 4000,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "light",
      // });
    }
  };

  const getAllOrder = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getAllContactInfo`,
      method: "get",
    };

    try {
      const response = await axios.request(config);
      console.log("Hello");
      console.log(response?.data);

      if (response?.data?.status === true) {
        setContactInfo(response?.data?.data);
        // toast.success("Product fetched successfully", {
        //   position: "bottom-right",
        //   autoClose: 4000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "light",
        // });
      } else if (response?.data?.status === false) {
        const { response_code } = response.data;
        const errorMessage =
          response_code === 500 || response_code === 404
            ? "Problem with data fetching"
            : "Unknown error";

        // toast.error(errorMessage, {
        //   position: "bottom-right",
        //   autoClose: 4000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "light",
        // });
      }
    } catch (error) {
      const errorCode = error?.response?.data?.response_code;
      const errorMessage =
        errorCode === 401
          ? "Your token is expired. Please login again."
          : "Problem with data fetching";

      const toastType = errorCode === 401 ? toast.error : toast.warn;

      // toastType(errorMessage, {
      //   position: "bottom-right",
      //   autoClose: 4000,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "light",
      // });
    }
  };

  useEffect(() => {
    getAllContactInfo();
    getAllOrder();
  }, []);

  useEffect(() => {
    setSearchField({
      product: "",
      order: "",
      blogs: "",
      users: "",
    });
  }, [value]);

  const handleSearchFields = (e) => {
    e.preventDefault();
    setSearchField({
      ...searchField,
      [e.target.name]: e.target.value,
    });
  };

  const onLogOut = () => {
    localStorage.clear();
    navigate(`/login`);
  };

  const CreateNewHandler = () => {
    navigate("/createProduct");
  };

  const [activeFilter, setActiveFilter] = useState({
    filter: "",
  });

  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const getAllProduct = (page) => {
    const config = {
      url: `${
        process.env.REACT_APP_BASE_URL
      }api/allProducts/null?page=${page}&limit=${20}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          const data = response?.data;
          setProducts((prevProducts) => [...prevProducts, ...data?.data]);
          // setShowProduct((prevProducts) => [...prevProducts, ...data?.data]);
          setTotalPages(data.pagination.totalPages);
          setCurrentPage(data.pagination.currentPage);
        }
        if (!response?.data?.status) {
          if (response?.data?.response_code === 500) {
            // Handle error 500
          } else if (response?.data?.response_code === 404) {
            // Handle error 404
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code === 401) {
          // Handle token expiration
        } else {
          // Handle other errors
        }
      });
  };

  const handleLoadMore = () => {
    if (currentPage < totalPages) {
      getAllProduct(currentPage + 1);
    }
  };

  const [coupons, setCouponse] = useState([]);

  const getAllCoupons = async () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getDiscountCouponsforAdmin`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setCouponse(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [returnOrder, setReturnOrder] = useState([]);
  const [cancelReason, setCancelReason] = useState("");
  const [productNameProduct, setProductNameProduct] = useState("");
  const [cancelProductId, setCancelProductId] = useState(null);

  const getAllReturnOrderRequest = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `return/getReturnDetails`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setReturnOrder(response?.data?.data);
          // toast.success("Case Study get Successfully", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "dark",
          // });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleReturn = (ReturnId) => {
    console.log(ReturnId);
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/ship/createRet`,
      method: "post",
      data: {
        orderId: ReturnId,
        // userId: user._id,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setReturnOrder(response?.data?.data);
          toast.success("Case Study get Successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleCancel = (ReturnId) => {
    if (cancelReason.length == 0) {
      toast.warn("Fill Reason Of Cancel", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });
    }
    const config = {
      url: process.env.REACT_APP_BASE_URL + `return/cancelReturnOrder`,
      method: "post",
      data: {
        reasonOfCancel: cancelReason,
        ReturnId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setReturnOrder(response?.data?.data);
          toast.success("Case Study get Successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handlePay = (ReturnId) => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/pay/refund`,
      method: "post",
      data: {
        orderId: ReturnId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          setReturnOrder(response?.data?.data);
          toast.success("Case Study get Successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getAllProduct();
    getAllContactInfo();
    getAllCoupons();
    getAllReturnOrderRequest();
  }, []);

  return (
    <div className="admin-wrapper ">
      <div className="row row-wrapper">
        <div className="col-md-3 admin-sub-wrapper navbar navbar-expand-md   bg-body-tertiary">
          <button
            class="d-flex d-md-none justify-content-around w-100 sticky navbar-toggler mt-2 align-item-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <p className="mb-0">View Admin Menu</p>
            <i class="bi bi-chevron-down"></i>
          </button>
          <div
            className="div-admin collapse  w-100 navbar-collapse"
            id="navbarSupportedContent"
          >
            <div className="w-100">
              <div className="admin-logo-section">
                <div className="top-div"></div>
                <div className="logo">
                  <div className="image">
                    <h1>LOGO</h1>
                  </div>
                </div>
              </div>
              <div className="sidebar">
                <div>
                  <div
                    className="sidebar-title active-link-admin"
                    onClick={dashboardHandler}
                  >
                    <div className="icon">
                      <i class="bi bi-bar-chart-fill"></i>
                    </div>
                    <div className="title">Dashboard</div>
                  </div>
                </div>

                <div>
                  <div
                    className="sidebar-title"
                    id="AllOrders"
                    onClick={() => setValue(0)}
                  >
                    <div className="icon">
                      <i class="bi bi-shop"></i>
                    </div>
                    <div className="title">All Orders</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title" onClick={() => setValue(3)}>
                    <div className="icon">
                      <i class="bi bi-box"></i>
                    </div>
                    <div className="title">Products</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title" onClick={() => setValue(5)}>
                    <div className="icon">
                      <i class="bi bi-box"></i>
                    </div>
                    <div className="title">Contact Info</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title" onClick={() => setValue(6)}>
                    <div className="icon">
                      <i class="bi bi-box"></i>
                    </div>
                    <div className="title">Coupons For Discount</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title" onClick={() => setValue(10)}>
                    <div className="icon">
                      <i class="bi bi-box"></i>
                    </div>
                    <div className="title">Return Order</div>
                  </div>
                </div>

                <div>
                  <div>
                    <div className="h3-titlfe">ACCOUNT PAGES</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title " onClick={() => setValue(2)}>
                    <div className="icon">
                      <i class="bi bi-person-circle"></i>
                    </div>
                    <div className="title">User</div>
                  </div>
                </div>

                <div>
                  <div className="sidebar-title" onClick={onLogOut}>
                    <div className="icon">
                      <i class="bi bi-person"></i>
                    </div>
                    <div className="title">Logout</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-9 admin-suber-wrapper">
          {value == 0 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="admin-header-nav">
                    <div className="tab">
                      <span className="tab1">Pages</span>
                      <span>/Orders</span>
                      <div className="nav-title">All Orders</div>
                    </div>

                    <div className="nav-rightContent">
                      <div className="admin-right" onClick={onLogOut}>
                        <div className="logout-button lg-admin-button">
                          <span style={{ marginLeft: "15px" }}>
                            <i class="bi bi-person"></i>
                          </span>
                          <span>Logout</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 1 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="admin-header-nav">
                    <div className="tab">
                      <span className="tab1">Pages</span>
                      <span>/Dashboard</span>
                      <div className="nav-title">Dashboard</div>
                    </div>

                    <div className="nav-rightContent">
                      <div className="admin-right">
                        <div
                          className="logout-button lg-admin-button"
                          onClick={onLogOut}
                        >
                          <span style={{ marginLeft: "15px" }}>
                            <i class="bi bi-person"></i>
                          </span>
                          <span>Logout</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 2 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="admin-header-nav">
                    <div className="tab">
                      <span className="tab1">Pages</span>
                      <span>/User</span>
                      <div className="nav-title">Users</div>
                    </div>

                    <div className="nav-rightContent">
                      <div className="admin-right">
                        <div
                          className="logout-button lg-admin-button"
                          onClick={onLogOut}
                        >
                          <span style={{ marginLeft: "15px" }}>
                            <i class="bi bi-person"></i>
                          </span>
                          <span>Logout</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 3 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="tab">
                    <span className="tab1">Pages</span>
                    <span>/Products</span>
                  </div>
                  <div className="nav-title">Products</div>
                  <div className="nav-rightContent">
                    <button
                      className="admin-btn-nav"
                      onClick={CreateNewHandler}
                    >
                      <i class="bi bi-plus-lg"></i> Create New
                    </button>
                    <div className="admin-right">
                      <div className="logout-button" onClick={onLogOut}>
                        <span style={{ marginLeft: "15px" }}>
                          <i class="bi bi-person"></i>
                        </span>
                        <span>Logout</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 5 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="tab">
                    <span className="tab1">Pages</span>
                    <span>/Contact Info</span>
                  </div>
                  <div className="nav-title">Contact Info</div>
                  <div className="nav-rightContent">
                    {/* <button
                      className="admin-btn-nav"
                      onClick={CreateNewBlogHandler}
                    >
                      <i class="bi bi-plus-lg"></i> Create New
                    </button> */}
                    {/* <div className="admin-right">
                      <div className="logout-button" onClick={onLogOut}>
                        <span style={{ marginLeft: "15px" }}>
                          <i class="bi bi-person"></i>
                        </span>
                        <span>Logout</span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 6 && (
            <nav className="nav-admin-page">
              <div className="admin-navbar">
                <div className="nav-header">
                  <div className="tab">
                    <span className="tab1">Pages</span>
                    <span>/Coupons</span>
                  </div>
                  <div className="nav-title">All Coupons</div>
                  <div className="nav-rightContent">
                    <button
                      className="admin-btn-nav"
                      onClick={() => navigate("/createCoupons")}
                    >
                      <i class="bi bi-plus-lg"></i> Create New
                    </button>
                    <div className="admin-right">
                      <div className="logout-button" onClick={onLogOut}>
                        <span style={{ marginLeft: "15px" }}>
                          <i class="bi bi-person"></i>
                        </span>
                        <span>Logout</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          )}

          {value == 0 && (
            <div className="card admin-table-card">
              <div className="subHeading">
                <div className="admin-card-heading">
                  <h1 className="h1">All Orders</h1>
                  <div className="admin-card-header">
                    <h3 className="h3">Active Orders</h3>
                    {/* <div className="admin-input-dropdown">
                      <input
                          type="text"
                          className="nav-input"
                          style={{ width: "15rem" }}
                          placeholder="Search"
                        /> 
                      <div className="short">
                        <select
                          type="text"
                          name="input"
                          id="filterDropdown"
                          placeholder="Short by:Newest "
                          onChange={(e) => applyFilter(e, 2)}
                          value={activeFilter.filter}
                        >
                          <option value=""> Filter By : Delievery </option>
                          <option value="By Self">By Self</option>
                          <option value="By ShipRocket">By ShipRocket</option>
                        </select>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="admin-table-div">
                  <table class="table head-table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" className="th">
                          Sr.No.
                        </th>
                        <th scope="col" className="th">
                          OrderId
                        </th>
                        <th scope="col" className="th">
                          Price
                        </th>
                        <th scope="col" className="th" data-category="By Self">
                          Payment
                        </th>
                        {/* <th scope="col" className="th">
                          Delivery Option
                        </th> */}
                        <th scope="col" className="th">
                          Shippment Order Status
                        </th>
                        <th scope="col" className="th">
                          No of Product
                        </th>
                        <th scope="col" className="th">
                          Order On
                        </th>

                        <th scope="col" className="th">
                          Process Order
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders
                        ?.filter((order) => {
                          // If no filter is selected, show all orders
                          if (activeFilter?.filter === "") return true;
                          // If a filter is selected, only show orders that match the filter
                          return order?.status === activeFilter?.filter;
                        })
                        .map((order, index) => {
                          return (
                            <tr key={order?._id}>
                              <th scope="row table-center">{index + 1}</th>
                              <td
                                className="td order-link"
                                onClick={() =>
                                  navigate(
                                    `/OrderConfirmationPage/${order?._id}`
                                  )
                                }
                              >
                                {/* <Link */}
                                {/* > */}
                                ...{order?._id.slice(-4)}
                                {/* </Link> */}
                              </td>

                              {/* <td className="td table-center" onClick={(e)=>{navigate(``)}}>...{order._id.slice(-4)}</td> */}
                              <td className="td table-center">
                                {order?.total_amount}
                              </td>

                              <td className="td table-center">
                                <div>{order?.payment_method}</div>
                              </td>

                              {/* <td className="td table-center">
                                {order?.status}
                              </td> */}

                              <p className="td table-center">
                                {order?.orderStatus}
                              </p>

                              <td className="td table-center">
                                {order?.products.length}
                              </td>
                              <td className="td table-center">
                                {`${dayjs(order?.createdAt).format(
                                  "MMMM D, YYYY"
                                )}`}
                              </td>
                              <td className="td table-center">
                                {/* <Link to={`/adminProcess/${order._id}`}> */}
                                <i
                                  onClick={() =>
                                    navigate(`/adminProcess/${order._id}`)
                                  }
                                  class="bi bi-check2-square"
                                  style={{
                                    fontSize: "2rem",
                                    textAlign: "center",
                                    textDecoration: "none",
                                  }}
                                ></i>
                                {/* </Link> */}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {value == 3 && (
            <div className="card admin-product-card">
              <div className="subHeading">
                <div className="admin-card-heading">
                  <h1 className="h1">All Products</h1>
                  <div className="admin-card-header">
                    <h3 className="h3">Products</h3>
                    <div className="admin-input-dropdown">
                      <input
                        type="text"
                        name="product"
                        className="nav-input"
                        onChange={(e) => handleSearchFields(e)}
                        style={{ width: "15rem" }}
                        placeholder=" Search"
                      />
                      {/* <div className="short">
                          <select
                            type="text"
                            name="input"
                            id="input"
                            placeholder="Short by:Newest "
                          >
                            <option>Short by : Newest</option>
                            <option>yes</option>
                          </select>
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className="admin-table-div">
                  <table class="table head-table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" className="th">
                          Sr.No.
                        </th>
                        <th scope="col" className="th">
                          Product Name
                        </th>
                        <th scope="col" className="th">
                          Price
                        </th>
                        <th scope="col" className="th">
                          Category
                        </th>
                        <th scope="col" className="th">
                          Discount
                        </th>

                        <th scope="col" className="th">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {products.map((product, index) => {
                        return (
                          <tr>
                            <td className="td table-center">{index + 1}</td>
                            {/* <td className="td">
                              <img
                                src={product.image}
                                className="img-product-admin-data"
                              />
                            </td> */}
                            <td className="td table-center">
                              {product.productName}
                            </td>
                            <td className="td table-center">{product.price}</td>
                            <td className="td table-center">
                              {product?.categoryId?.categoryName}
                            </td>
                            <td className="td table-center">
                              {product?.discount}%
                            </td>
                            {/* <td className="td table-center">{product.gstSlab}%</td> */}

                            <td className="td table-center">
                              <span className="td-edit-icon ">
                                <i
                                  class="bi bi-pencil-square"
                                  onClick={(e) =>
                                    navigate(`/updateProduct/${product._id}`)
                                  }
                                ></i>
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {currentPage < totalPages && (
                    <button
                      className="load-more-btn"
                      onClick={handleLoadMore}
                      disabled={loading}
                      style={{ width: "fit-content", height: "fit-content" }}
                    >
                      {loading ? "Loading..." : "Load More..."}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {value == 5 && (
            <div className="container mt-5">
              <h2>Contact Information Dashboard</h2>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Message</th>
                    {/* <th>Created At</th> */}
                  </tr>
                </thead>
                <tbody>
                  {contactInfo.map((contact) => (
                    <tr key={contact._id}>
                      <td>{contact.name}</td>
                      <td>{contact.email}</td>
                      <td>{contact.message}</td>
                      {/* <td>{new Date(contact.createdAt).toLocaleString()}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {value == 6 && (
            <div className="card admin-product-card">
              <div className="subHeading">
                <div className="admin-card-heading">
                  <h1 className="h1">All Coupons</h1>
                  <div className="admin-card-header">
                    <h3 className="h3">Discount Coupons</h3>
                  </div>
                </div>
                <div className="admin-table-div">
                  <table className="table head-table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" className="th">
                          Sr.No.
                        </th>
                        <th scope="col" className="th">
                          Code
                        </th>
                        <th scope="col" className="th">
                          Code
                        </th>
                        <th scope="col" className="th">
                          Discount
                        </th>
                        <th scope="col" className="th">
                          Active
                        </th>
                        <th scope="col" className="th">
                          Show All User
                        </th>
                        <th scope="col" className="th">
                          Update Coupons
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {coupons.map((coupon, index) => {
                        return (
                          <tr key={coupon._id}>
                            <td className="td table-center">{index + 1}</td>
                            {/* Render the "Coupons Code" cell conditionally */}
                            <td className="td table-center">{coupon?.code}</td>
                            <td className="td table-center">{coupon?.code}</td>
                            <td className="td table-center">
                              {coupon?.discountPercent}%
                            </td>
                            <td className="td table-center">
                              {coupon?.active === true ? "True" : "False"}
                            </td>
                            <td className="td table-center">
                              {coupon?.show === true ? "True" : "False"}
                            </td>

                            <td className="td table-center">
                              <span className="td-edit-icon">
                                <i
                                  className="bi bi-pencil-square"
                                  onClick={(e) =>
                                    navigate(`/updateCoupons/${coupon._id}`)
                                  }
                                ></i>
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {value == 10 && (
            <div className="card admin-table-card">
              <div className="subHeading">
                <div className="admin-card-heading">
                  <h1 className="h1">All Return Order</h1>
                  <div className="admin-card-header">
                    {/* <h3 className="h3">Active Return Order</h3> */}
                    {/* <div className="admin-input-dropdown">
                    <input
                        type="text"
                        className="nav-input"
                        style={{ width: "15rem" }}
                        placeholder="Search"
                      /> 
                    <div className="short">
                      <select
                        type="text"
                        name="input"
                        id="filterDropdown"
                        placeholder="Short by:Newest "
                        onChange={(e) => applyFilter(e, 2)}
                        value={activeFilter.filter}
                      >
                        <option value=""> Filter By : Delievery </option>
                        <option value="By Self">By Self</option>
                        <option value="By ShipRocket">By ShipRocket</option>
                      </select>
                    </div>
                  </div> */}
                  </div>
                </div>
                <div className="admin-table-div">
                  <table class="table head-table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" className="th">
                          Sr.No.
                        </th>
                        <th scope="col" className="th">
                          OrderId
                        </th>
                        <th scope="col" className="th">
                          Price
                        </th>
                        <th scope="col" className="th" data-category="By Self">
                          Payment
                        </th>
                        {/* <th scope="col" className="th">
                        Delivery Option
                      </th> */}
                        <th scope="col" className="th">
                          Shippment Order Status
                        </th>
                        <th scope="col" className="th">
                          No of Product
                        </th>
                        <th scope="col" className="th">
                          Order On
                        </th>

                        <th scope="col" className="th">
                          Process Order
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {returnOrder
                        ?.filter((order) => {
                          // If no filter is selected, show all orders
                          if (activeFilter?.filter === "") return true;
                          // If a filter is selected, only show orders that match the filter
                          return order?.status === activeFilter?.filter;
                        })
                        .map((order, index) => {
                          return (
                            <tr key={order?._id}>
                              <th scope="row table-center">{index + 1}</th>
                              <td
                                className="td order-link"
                                onClick={() =>
                                  navigate(
                                    `/OrderConfirmationPage/${order?._id}`
                                  )
                                }
                              >
                                ...{order?._id.slice(-4)}
                              </td>

                              <td className="td table-center">
                                {order?.price}
                              </td>

                              <td className="td table-center">
                                <div>{order?.transactionStatus}</div>
                              </td>

                              <p className="td table-center">{order?.status}</p>

                              <td className="td table-center">
                                {order?.products.length}
                              </td>
                              <td className="td table-center">
                                {`${dayjs(order?.createdAt).format(
                                  "MMMM D, YYYY"
                                )}`}
                              </td>
                              <td className="td table-center">
                                <Link to={`/returnAdminProcess/${order._id}`}>
                                  <i
                                    class="bi bi-check2-square"
                                    style={{
                                      fontSize: "2rem",
                                      textAlign: "center",
                                      textDecoration: "none",
                                    }}
                                  ></i>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Dashboard;
